<div class="c-loader-container" cypressTag="General.Loading">
	<div class="c-loader">
		<span></span>
	</div>

	@if (label) {
		<p>{{ label }}</p>
	}
</div>
